import { makeStyles } from '@mui/styles';
import { Switch, styled } from '@mui/material';

export const useStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: 'var(--background-color)',
    backgroundImage: (props) => `url("${props.bg}")`,
    width: '100%',
    minHeight: 'var(--browse-height, 100vh)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    display: 'flex',
    flexDirection: 'column',
    backgroundPositionY: '-20px',
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 150px 15px',
    [theme.breakpoints.down('md')]: {
      padding: '0 15px 15px',
    },
  },
  headerTop: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    flexWrap: 'wrap',
  },
  logoWrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    padding: '1.5rem 0',
    [theme.breakpoints.down('sm')]: {
      padding: 15,
      width: 'auto',
    },
  },
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    padding: '0 150px',
    position: 'relative',
    [theme.breakpoints.down('md')]: {
      justifyContent: 'space-between',
      padding: '0 20px',
    },
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'space-between',
      padding: 0,
      flexWrap: 'wrap',
    },
  },
  switchesContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 0,
    position: 'absolute',
    right: 150,
    [theme.breakpoints.down('md')]: {
      right: 20,
    },
    [theme.breakpoints.down('sm')]: {
      position: 'static',
      marginTop: 10,
      right: 'auto',
    },
  },
  switchContainer: {
    display: 'flex',
    gap: 5,
    alignItems: 'center',
    marginRight: 'auto',
  },
  logoLink: {
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      position: 'static',
      transform: 'none',
    },
  },
  logo: {
    maxWidth: 350,
    width: 350,
    height: 'auto',
    [theme.breakpoints.down('sm')]: {
      maxWidth: 195,
    },
  },
  divider: {
    width: '100%',
    height: 1,
    backgroundColor: 'var(--divider-color)',
    margin: '0.7rem 0',
  },
  showMoreButton: {
    color: 'var(--text-color) !important',
    fontFamily: 'Montserrat',
    fontSize: 14,
    fontWeight: 800,
    marginTop: '1rem',
    backgroundImage: (props) => `url("${props.bgBtn}")`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    '&:hover': {
      backgroundColor: 'rgba(70, 192, 236, 0.04)',
    },
  },
  statsWrapper: {
    padding: '0 150px',
  },
  headerVisible: {},
  unsubscribeWrapper: {
    backgroundColor: 'var(--background-color)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    padding: '20px',
    backgroundImage: (props) => `url(${props.bg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    '& .MuiTypography-root': {
      color: 'var(--text-color)',
      textAlign: 'center',
      padding: '20px',
      borderRadius: '8px',
    },
    '& .MuiCircularProgress-root': {
      color: 'var(--text-color)',
    },
  },
}));

export const ThemeSwitch = styled(Switch, {
  shouldForwardProp: (prop) => prop !== 'moonIcon',
})(({ theme, moonIcon }) => ({
  width: 72,
  height: 48,
  padding: 8,
  marginLeft: 5,
  margin: '0 0 3px 5px',
  scale: 0.8,
  [theme.breakpoints.down('sm')]: {
    margin: '0 0 15px'
  },
  '& .MuiSwitch-input': {
    [theme.breakpoints.down('sm')]: {
      left: '0 !important',
      width: '100% !important',
    },
  },
  '& .MuiSwitch-switchBase': {
    margin: 1,
    padding: 0,
    transform: 'translateX(8px)',
    top: 8,
    transition: 'transform 0.3s ease, background-color 0.3s ease',
    '&.Mui-checked': {
      color: '#000000',
      transform: 'translateX(32px)',
      '& .MuiSwitch-thumb:before': {
        backgroundImage: `url(${moonIcon})`,
        backgroundSize: '23px 23px',
      },
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: '#333',
      },
    },
    '& + .MuiSwitch-track': {
      opacity: 1,
      backgroundColor: '#fff',
    },
  },
  '& .MuiSwitch-thumb': {
    backgroundColor: 'var(--accent-primary)',
    width: 32,
    height: 32,
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)',
    transition: 'transform 0.3s ease, background-color 0.3s ease',
    '&:before': {
      content: "''",
      position: 'absolute',
      width: '100%',
      height: '100%',
      left: 0,
      top: 0,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
        '#fff'
      )}" d="M9.305 1.667V3.75h1.389V1.667h-1.39zm-4.707 1.95l-.982.982L5.09 6.072l.982-.982-1.473-1.473zm10.802 0L13.927 5.09l.982.982 1.473-1.473-.982-.982zM10 5.139a4.872 4.872 0 00-4.862 4.86A4.872 4.872 0 0010 14.862 4.872 4.872 0 0014.86 10 4.872 4.872 0 0010 5.139zm0 1.389A3.462 3.462 0 0113.471 10a3.462 3.462 0 01-3.473 3.472A3.462 3.462 0 016.527 10 3.462 3.462 0 0110 6.528zM1.665 9.305v1.39h2.083v-1.39H1.666zm14.583 0v1.39h2.084v-1.39h-2.084zM5.09 13.928L3.616 15.4l.982.982 1.473-1.473-.982-.982zm9.82 0l-.982.982 1.473 1.473.982-.982-1.473-1.473zM9.305 16.25v2.083h1.389V16.25h-1.39z"/></svg>')`,
    },
  },
  '& .MuiSwitch-track': {
    opacity: 1,
    borderRadius: 24,
    transition: 'background-color 0.3s ease',
    border: '1px solid var(--divider-color)',
  },
  '&:hover': {
    '& .MuiSwitch-thumb': {
      transform: 'scale(1.1)',
    },
  },
}));

export const useSettingsStyles = makeStyles((theme) => ({
  container: {
    padding: '20px',
    maxWidth: '800px',
    margin: '0 auto',
  },
  formGroup: {
    marginBottom: '20px',
  },
  label: {
    display: 'block',
    marginBottom: '8px',
    fontWeight: 'bold',
  },
  textarea: {
    width: '100%',
    padding: '10px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    fontFamily: 'inherit',
    resize: 'vertical',
  },
  saveButton: {
    backgroundColor: '#007bff',
    color: 'white',
    padding: '10px 20px',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#0056b3',
    },
  },
  error: {
    color: '#dc3545',
    marginBottom: '1rem',
    padding: '0.5rem',
    borderRadius: '4px',
    backgroundColor: '#f8d7da',
  },
}));
